import moment from 'moment'
import { range } from 'ramda'
import { Observable, of } from 'rxjs'
import { delay } from 'rxjs/operators'

import { IOpportunity } from 'api/customer/types'
import randomUtil from 'utils/random'

const random = (...args) => randomUtil(...args).toFixed(0)

// this is tmp, in reality, the endpoint will just return data & a reflection of
// the params used in the query...
const EMPTY_SERIES = []

const generateRandomConversationData = (startDate, endDate, scale) => {
  return range(0, endDate.diff(startDate, 'days')).map((i) => [
    moment(startDate).add(i, 'days').format('YYYY-MM-DD'),
    randomUtil(scale, 3 * scale),
  ])
}
const OPPORTUNITY_TYPES = [
  'New Buisness',
  'Expansion',
  'Reactivation',
  'Upgrade',
  'Cross-Sell',
]
const HEATMAP_SERIES = [
  [0, 0, 52],
  [0, 1, 20],
  [0, 2, 39],
  [0, 3, 90],
  [0, 4, 34],
  [0, 5, 24],
  [0, 6, 48],
  [0, 7, 76],
  [0, 8, 27],
  [0, 9, 16],
  [0, 10, 9],
  [0, 11, 82],
  [0, 12, 52],
  [0, 13, 73],
  [0, 14, 53],
  [0, 15, 85],
  [0, 16, 93],
  [0, 17, 80],
  [0, 18, 92],
  [0, 19, 36],
  [0, 20, 14],
  [0, 21, 83],
  [0, 22, 14],
  [0, 23, 75],
  [1, 0, 1],
  [1, 1, 84],
  [1, 2, 78],
  [1, 3, 36],
  [1, 4, 7],
  [1, 5, 74],
  [1, 6, 92],
  [1, 7, 77],
  [1, 8, 6],
  [1, 9, 77],
  [1, 10, 72],
  [1, 11, 41],
  [1, 12, 82],
  [1, 13, 95],
  [1, 14, 72],
  [1, 15, 69],
  [1, 16, 77],
  [1, 17, 16],
  [1, 18, 46],
  [1, 19, 25],
  [1, 20, 6],
  [1, 21, 60],
  [1, 22, 83],
  [1, 23, 19],
  [2, 0, 92],
  [2, 1, 31],
  [2, 2, 41],
  [2, 3, 89],
  [2, 4, 22],
  [2, 5, 67],
  [2, 6, 56],
  [2, 7, 96],
  [2, 8, 7],
  [2, 9, 56],
  [2, 10, 81],
  [2, 11, 92],
  [2, 12, 59],
  [2, 13, 46],
  [2, 14, 54],
  [2, 15, 18],
  [2, 16, 24],
  [2, 17, 26],
  [2, 18, 61],
  [2, 19, 93],
  [2, 20, 90],
  [2, 21, 51],
  [2, 22, 85],
  [2, 23, 51],
  [3, 0, 87],
  [3, 1, 30],
  [3, 2, 0],
  [3, 3, 28],
  [3, 4, 10],
  [3, 5, 86],
  [3, 6, 91],
  [3, 7, 63],
  [3, 8, 80],
  [3, 9, 63],
  [3, 10, 99],
  [3, 11, 41],
  [3, 12, 1],
  [3, 13, 46],
  [3, 14, 53],
  [3, 15, 0],
  [3, 16, 18],
  [3, 17, 36],
  [3, 18, 39],
  [3, 19, 46],
  [3, 20, 0],
  [3, 21, 13],
  [3, 22, 73],
  [3, 23, 61],
  [4, 0, 41],
  [4, 1, 10],
  [4, 2, 88],
  [4, 3, 5],
  [4, 4, 82],
  [4, 5, 9],
  [4, 6, 14],
  [4, 7, 53],
  [4, 8, 56],
  [4, 9, 77],
  [4, 10, 30],
  [4, 11, 31],
  [4, 12, 30],
  [4, 13, 37],
  [4, 14, 11],
  [4, 15, 76],
  [4, 16, 97],
  [4, 17, 12],
  [4, 18, 16],
  [4, 19, 58],
  [4, 20, 55],
  [4, 21, 32],
  [4, 22, 89],
  [4, 23, 71],
  [5, 0, 87],
  [5, 1, 54],
  [5, 2, 12],
  [5, 3, 36],
  [5, 4, 77],
  [5, 5, 17],
  [5, 6, 42],
  [5, 7, 10],
  [5, 8, 21],
  [5, 9, 99],
  [5, 10, 82],
  [5, 11, 49],
  [5, 12, 97],
  [5, 13, 35],
  [5, 14, 64],
  [5, 15, 39],
  [5, 16, 10],
  [5, 17, 4],
  [5, 18, 41],
  [5, 19, 55],
  [5, 20, 6],
  [5, 21, 88],
  [5, 22, 35],
  [5, 23, 81],
  [6, 0, 55],
  [6, 1, 52],
  [6, 2, 67],
  [6, 3, 94],
  [6, 4, 22],
  [6, 5, 28],
  [6, 6, 9],
  [6, 7, 65],
  [6, 8, 39],
  [6, 9, 6],
  [6, 10, 41],
  [6, 11, 32],
  [6, 12, 38],
  [6, 13, 67],
  [6, 14, 46],
  [6, 15, 50],
  [6, 16, 54],
  [6, 17, 69],
  [6, 18, 80],
  [6, 19, 15],
  [6, 20, 39],
  [6, 21, 90],
  [6, 22, 89],
  [6, 23, 44],
]

const URL_DATA = [
  {
    url: 'www.yoursite.com/info',
    value: random(100, 500),
  },
  {
    url: 'www.yoursite.com/blog',
    value: random(500, 1200),
  },
  {
    url: 'www.yoursite.com/pricing',
    value: random(1500, 2000),
  },
  {
    url: 'www.yoursite.com/signup',
    value: random(2500, 2800),
  },
  {
    url: 'www.yoursite.com',
    value: random(2900, 3500),
  },
]

const TOP_TAGS_DATA = [
  {
    tag: 'Engaged',
    value: random(100, 500),
  },
  {
    url: 'Sales',
    value: random(500, 1200),
  },
]

const REP_DATA = [
  {
    user: true,
    value: random(500, 600),
  },
  {
    user: true,
    value: random(400, 500),
  },
  {
    user: true,
    value: random(300, 400),
  },
  {
    user: true,
    value: random(200, 300),
  },
  {
    user: true,
    value: random(200, 300),
  },
]

const REP_PERF_DATA = [
  {
    user: true,
    responseTime: 229643,
    convoLength: 2296430,
    newConvos: 1304,
  },
  {
    user: true,
    responseTime: 329643,
    convoLength: 3296430,
    newConvos: 1000,
  },
  {
    user: true,
    responseTime: 289643,
    convoLength: 2964300,
    newConvos: 888,
  },
  {
    user: true,
    responseTime: 429643,
    convoLength: 2264300,
    newConvos: 780,
  },
]

const MEDIAN_RESPONSE_TIME = {
  time: 203287,
}

const MEDIAN_CONVERSATION_LENGTH = {
  time: 203287,
}

const USER_AVAILABILITY_DATA = [
  {
    userId: '100000',
    userName: 'Karl White',
    secondsActive: 1590000,
    secondsActivePerDay: 74400,
  },
  {
    userId: '324106',
    userName: 'Fernanda Lockhart',
    secondsActive: 2160000,
    secondsActivePerDay: 86400,
  },
  {
    userId: '13897',
    userName: 'craig@drift.com',
    secondsActive: 184000,
    secondsActivePerDay: 76000,
  },
  {
    userId: '18226',
    userName: 'Elon Musk',
    secondsActive: 750000,
    secondsActivePerDay: 6400,
  },
  {
    userId: '16954',
    userName: 'Jeff Bezos',
    secondsActive: 0,
    secondsActivePerDay: 0,
  },
]

// Delay reponse otherwise UI is stuck in the pending state
function fetchConversationsDataRx(queryConfig) {
  switch (queryConfig.metric) {
    case 'conversationsHeatmap':
      return of(HEATMAP_SERIES)
    case 'repTable':
      return of(REP_DATA).pipe(delay(1000))
    case 'urlTable':
      return of(URL_DATA).pipe(delay(1000))
    case 'topTagsTable':
      return of(TOP_TAGS_DATA).pipe(delay(1000))
    case 'newConversations':
      return of(
        generateRandomConversationData(
          moment(queryConfig.startDate),
          moment(queryConfig.endDate),
          5
        )
      )
    case 'repPerformance':
      return of(REP_PERF_DATA).pipe(delay(1000))
    case 'medianResponseTime':
      return of(MEDIAN_RESPONSE_TIME).pipe(delay(1000))
    case 'medianConversationLength':
      return of(MEDIAN_CONVERSATION_LENGTH).pipe(delay(1000))
    case 'medianResponseTimeLine':
      return of(
        generateRandomConversationData(
          moment(queryConfig.startDate),
          moment(queryConfig.endDate),
          84480
        )
      )
    case 'medianConversationLengthLine':
      return of(
        generateRandomConversationData(
          moment(queryConfig.startDate),
          moment(queryConfig.endDate),
          84480
        )
      )
    default:
      return of(EMPTY_SERIES)
  }
}

export function fetchConversationsData(queryConfig) {
  return fetchConversationsDataRx(queryConfig) as Observable<any>
}

export function fetchAvailabilityData() {
  return of(USER_AVAILABILITY_DATA).pipe(delay(1000))
}

export const fetchOpportunities = (
  startDate: string,
  endDate: string,
  scale: number
): Promise<{ results: Record<string, IOpportunity[]> }> => {
  return new Promise((resolve) => {
    const currDate = moment(startDate).startOf('day')
    const lastDate = moment(endDate).startOf('day')

    const dates = [currDate.clone()]

    while (currDate.add(1, 'days').diff(lastDate) <= 0) {
      dates.push(currDate.clone())
    }
    setTimeout(
      () =>
        resolve({
          results: dates.reduce((obj, date) => {
            obj[date.format('YYYY-MM-DD')] = range(Math.random() * scale)(
              scale
            ).map(() => {
              return {
                Id: 'demo',
                Name: 'Demo Opportunity',
                Account: {
                  Id: 'demo',
                  Name: 'Demo Account',
                  AccountId: 'demo',
                  OwnerId: 'demo',
                  Website: 'Example.com',
                },
                Type: OPPORTUNITY_TYPES[
                  Math.floor(Math.random() * OPPORTUNITY_TYPES.length)
                ],
                Amount: Math.floor(Math.random() * scale * 1000),
                CloseDate: date.clone().add(Math.random() * scale, 'days'),
                CreatedDate: date,
                BaseURL: 'https://test.salesforce.com',
              }
            })
            return obj
          }, {}),
        }),
      2000
    )
  })
}

export const fetchConvoLinks = (): Promise<{
  conversationLinksByAccountId: Record<string, string>
}> => {
  return new Promise((resolve) =>
    setTimeout(
      () =>
        resolve({
          conversationLinksByAccountId: {
            demo: '/inboxes',
          },
        }),
      2000
    )
  )
}
